<template>
  <div class="ts-border ts-p-2 ts-rounded-md">
    <input
			v-model="search"
      type="text"
      class="ts-w-full ts-border ts-rounded-sm ts-px-2 ts-py-1 ts-outline-none"
      placeholder="Search"
    />
    <small class="ts-mt-1">
      <i>{{$t('productAssembly.clickAddItem')}}</i>
    </small>
    <div class="left-box ts-overflow-auto ts-p-2 ts-mt-2">
      <div
        class="ts-flex ts-justify-between"
        v-for="n in noneAssemblyProduct"
        :key="n.pro_sale_code_id"
      >
        <a href="#" @click.prevent="addItem(n)">{{ n.name }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
			search: '',
      model: {},
      newRow: {
        id: null,
        other_sale_code_id: null,
        quantity: 1
      }
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    noneAssemblyProduct() {
      return this.$store.state.product.assembly.productAssembly
        .filter(a => a.product_type_id != 1)
        .filter(
          a =>
            !_.includes(
              this.model.other_product_id_list.map(el => el.other_sale_code_id),
              a.pro_sale_code_id
            )
				)
				.filter(s => s.name.toLowerCase().indexOf(this.search.toLowerCase()) != -1)
    }
  },
  methods: {
    addItem(item) {
      this.model.other_product_id_list.push(
        _.clone({
          id: null,
          other_sale_code_id: item.pro_sale_code_id,
          quantity: 1
        })
      )
    }
  }
}
</script>

<style>
.left-box {
  min-height: 50vh;
  max-height: 55vh;
}
</style>